module.exports = __webpack_public_path__ + "static/media/icon1.44f4766f.svg";